import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ISalesByDayOfWeekApiService } from './sales-by-day-of-week-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { FindSalesByDayOfWeekQueryDto } from './dtos/find-sales-by-day-of-week.query.dto';
import { FindSalesByDayOfWeekResponseDto } from './dtos/find-sales-by-day-of-week.response.dto';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportSalesByDayOfWeekQueryDto } from './dtos/export-sales-by-day-of-week.query.dto';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';

@Injectable({
  providedIn: 'root',
})
export class SalesByDayOfWeekApiService implements ISalesByDayOfWeekApiService {
  private readonly ENDPOINT = 'day-of-week-transactions';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findSalesByDayOfWeek(
    query: FindSalesByDayOfWeekQueryDto
  ): Promise<FindSalesByDayOfWeekResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<
        SuccessResponse<{ dayOfWeek: FindSalesByDayOfWeekResponseDto }> // TODO: Simplify type
      >(`${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`, { params })
    );

    return response.data.dayOfWeek;
  }

  exportSalesByDayOfWeek(
    query: ExportSalesByDayOfWeekQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
